export default __webpack_public_path__ + "static/media/solar-installation.abb993bb.jpeg";